import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getPhoenixApiTenantUrl,
} from '@pflegenavi/shared-frontend/platform';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';
import type {
  ResidentControllerQueryTypes,
  ResidentControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';

export interface IResidentPhoenixApi extends Api {
  getResidentList(dataIn: {
    params: ResidentControllerQueryTypes['getResidentList'];
  }): Promise<ResidentControllerResultTypes['getResidentList']>;
}

export class ResidentPhoenixApi implements IResidentPhoenixApi {
  baseUrl: string;
  getResidentList: IResidentPhoenixApi['getResidentList'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    // Same pattern as service-provider-phoenix, receipt-batch-phoenix, etc.
    this.baseUrl = getPhoenixApiTenantUrl('service-provider', apiUrl);

    this.getResidentList = get({
      authContext,
      url: (opts) => {
        const queryParams = new URLSearchParams();
        queryParams.append('nursingHomeId', opts.nursingHomeId);
        queryParams.append(
          'globalServiceProviderId',
          opts.globalServiceProviderId
        );
        return `${this.baseUrl}/residents?${queryParams.toString()}`;
      },
    });
  }
}
